
import { VueModule } from '@Foundation/utilities';
import CaptchaEnterprise from './code/Scripts/components/captcha-enterprise.vue';

export default VueModule({
  components: {
    CaptchaEnterprise
  }
});
